import React, { Component } from 'react'

export default class Management extends Component {

  render() {
    return (
        <div>
          <div className="insid-header activity-header" style={{marginTop: '100px'}}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="insid-header-text activity-header-text">
                    <h1 className="wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                      Strategic management e controllo di gestione
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="activity about2">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-lg-12">
                  <div className="activity-text wow fadeIn animated" data-wow-duration=".5s" data-wow-delay=".2s">
                    <h2 className="activity-h2">Dettagli</h2>
                    <ul>
                      <li>Supporto operativo nell’<b>esecuzione</b> della <b>strategia</b> aziendale attraverso:</li>
                      <li className="list-none">
                        <ul className="list-square">
                          <li>valutazione della coerenza dei <b>processi</b> interni e dei <b>sistemi</b> (ERP ed applicativi specifici) in relazione alla strategia definita; consulenza, formazione e assistenza nelle attività di adeguamento eventualmente proposte.</li>
                          <li>valutazione adeguatezza risorse umane in relazione alla strategia definita.</li>
                        </ul>
                      </li>
                      <li>Consulenza e supporto operativo nello sviluppo di strumenti per la <b>pianificazione</b> ed il controllo della gestione e del rischio d’azienda, atti a guidare l’Azienda nella corretta esecuzione dei <b>programmi</b> e delle strategie:</li>
                      <li className="list-none">
                        <ul className="list-square">
                          <li><b>Business plan</b>, <b>Financial plan</b> e <b>budget</b>.</li>
                          <li><b>Reporting</b> e <b>Forecast</b>.</li>
                          <li><b>Balanced scorecard</b>.</li>
                        </ul>
                      </li>
                      <li>Supporto operativo nella velocizzazione del processo di reporting <b>direzionale</b> periodico.</li>
                      <li>Assistenza nella scelta della configurazione del costo di prodotto in funzione delle necessità e scopi aziendali (pricing, controllo industriale, valutazione scorte, etc.).</li>
                      <li>Supporto operativo nel calcolo del <b>costing</b> e delle marginalità per prodotto e/o linea di prodotto.</li>
                      <li>Supporto operativo per il calcolo del conto economico di commessa con evidenza dei costi diretti ed indiretti industriali e delle relative marginalità e risultati operativi; consulenza nello sviluppo di strumenti per il controllo di commessa.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/pages/management.it.js